import ReactMarkdown from 'react-markdown'
import Box from '@material-ui/core/Box'
import SignInNudge from '../../components/sign-in-nudge'
import ParticipantInformation from '../../components/participant-information'
import ContactInformation from '../../components/contact-information'
import MarketingOptIn from 'components/marketing-opt-in/marketing-opt-in'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'
import Button from '@material-ui/core/Button'
import ActionButton from '../action-button'
import GroupEventInfo from '../../components/group-event-info'
import Divider from '@material-ui/core/Divider'
import PriceDetails from '../../components/price-details'
import CoachInfo from '../../components/coach-info'
import React, { useEffect, useRef, useState } from 'react'
import { useAuth } from 'lib/auth'
import { CANCELLATION_POLICY } from '../../constants'
import { COACHING_CENTER_SLUGS } from 'utils/constants'
import useStyles from '../../components/group-event-registration-form.styles'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const ParticipantAndContactInformation = ({
  groupEvent,
  marketingOptInChecked,
  handleMarketingOptInChange,
  paymentRequired,
  setPaymentRequired,
  handleNext,
  steps,
  activeStep,
}) => {
  const { user, isConsumer } = useAuth()
  const descriptionRef = useRef(null)
  const isCoachingCenterGE = COACHING_CENTER_SLUGS.includes(
    groupEvent?.academy?.slug,
  )
  const MAX_LINES = isCoachingCenterGE ? 1000 : 50
  const [maxLines, setMaxLines] = useState(isCoachingCenterGE ? MAX_LINES : 2)
  const classes = useStyles({ maxLines })
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const description = isCoachingCenterGE
    ? groupEvent?.description + CANCELLATION_POLICY
    : groupEvent?.description
  const [showButton, setShowButton] = useState(false)
  const [isDescriptionClamped, setIsDescriptionClamped] = useState(false)
  const [showFullDescription, setShowFullDescription] = useState(
    isCoachingCenterGE,
  )
  const userIsNotOptedIn = !user?.marketingOptInAt
  const isAuthenticatedConsumer = user && isConsumer

  useEffect(() => {
    const contentElement = descriptionRef.current
    if (contentElement) {
      const isContentOverflowing =
        contentElement.scrollHeight > contentElement.clientHeight ||
        contentElement.scrollWidth > contentElement.clientWidth
      setIsDescriptionClamped(isContentOverflowing && !isCoachingCenterGE)
      setShowButton(isContentOverflowing || isCoachingCenterGE)
    }
  }, [description, isCoachingCenterGE])

  const handleFullDescription = e => {
    e.preventDefault()

    if (isDescriptionClamped) {
      setMaxLines(MAX_LINES)
      setShowFullDescription(true)
      setIsDescriptionClamped(false)
    } else {
      setMaxLines(2)
      setShowFullDescription(false)
      setIsDescriptionClamped(true)
    }
  }

  return (
    <>
      <Box
        mr={isMobile ? 0 : 2}
        style={{
          width: isMobile ? 'unset' : '525px',
        }}
        className={classes.stepContentWrapper}
      >
        <SignInNudge />
        <ParticipantInformation tags={groupEvent?.tags} />
        <Box mb={2}>
          <ContactInformation />
        </Box>
        <Box mb={4}>
          {userIsNotOptedIn && (
            <MarketingOptIn
              checked={marketingOptInChecked}
              onChange={handleMarketingOptInChange}
              useMarketingOptIn={'callout'}
            />
          )}
        </Box>
        {!isAuthenticatedConsumer && (
          <Typography variant="body2" className={classes.proceedingText}>
            By proceeding, you agree to PGA of America’s{' '}
            <Link
              className={classes.link}
              href="https://www.pga.com/pga-of-america/privacy-policy"
              target="_blank"
            >
              Privacy Policy
            </Link>{' '}
            and{' '}
            <Link
              className={classes.link}
              href="https://www.pga.com/pga-of-america/terms-of-service"
              target="_blank"
            >
              Terms of Service
            </Link>
            .
          </Typography>
        )}
        <Box display="flex" justifyContent="center">
          <ActionButton
            groupEvent={groupEvent}
            paymentRequired={paymentRequired}
            steps={steps}
            activeStep={activeStep}
            onClick={() =>
              handleNext({ fieldsToValidate: ['participants', 'contact'] })
            }
          />
        </Box>
      </Box>
      <Box
        style={{
          width: isMobile ? 'unset' : '480px',
          top: isMobile ? 'auto' : '48px',
        }}
        position={isMobile ? 'relative' : 'sticky'}
        className={classes.stepContentWrapper}
      >
        <GroupEventInfo groupEvent={groupEvent} />
        <Divider className={classes.horizontalDivider} />
        {isCoachingCenterGE && (
          <>
            <PriceDetails
              groupEvent={groupEvent}
              paymentRequired={paymentRequired}
              setPaymentRequired={setPaymentRequired}
            />
            <Divider className={classes.horizontalDivider} />
          </>
        )}
        <CoachInfo coach={groupEvent?.coach} />
        <Divider className={classes.horizontalDivider} />
        {description && (
          <div>
            <div>
              <Typography
                variant="subtitle1"
                component="h1"
                className={classes.subTitle}
              >
                Description
              </Typography>
              <div ref={descriptionRef} className={classes.clampedDescription}>
                <ReactMarkdown>{description}</ReactMarkdown>
              </div>
            </div>
            {showButton ? (
              <Button
                onClick={handleFullDescription}
                style={{ paddingLeft: 0 }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ color: theme.palette.primary.light }}
                >
                  {showFullDescription ? 'Read Less' : 'Read More'}
                </Typography>
              </Button>
            ) : null}
          </div>
        )}
        {!isCoachingCenterGE && (
          <>
            <Divider className={classes.horizontalDivider} />
            <PriceDetails
              groupEvent={groupEvent}
              paymentRequired={paymentRequired}
              setPaymentRequired={setPaymentRequired}
            />
          </>
        )}
      </Box>
    </>
  )
}

export default ParticipantAndContactInformation
